<template>
    <div>
        <div class="space-y-2">
            <div class="flex items-center gap-1">
                <TextInput
                    type="date"
                    v-model="dummyStartDate"
                    :name="`${RequestBodyKeyEnum.App_Availability_DateSpecificHours}[${index}][${RequestBodyKeyEnum.App_Availability_DateSpecificHour_StartDate}]`"
                    required
                />
                <TextInput
                    type="date"
                    v-model="dummyEndDate"
                    :name="`${RequestBodyKeyEnum.App_Availability_DateSpecificHours}[${index}][${RequestBodyKeyEnum.App_Availability_DateSpecificHour_EndDate}]`"
                    required
                />
                <Button
                    type="button"
                    iconName="trash"
                    color="danger-outline"
                    @click="handleDeleteDateSpecificHour()"
                />
            </div>
            <div
                v-if="localDateSpecificHours.timeRanges.length > 0"
                class="space-y-1"
            >
                <div
                    v-for="(
                        timeRange, timeRangeIndex
                    ) in localDateSpecificHours.timeRanges"
                    :key="timeRangeIndex"
                >
                    <div
                        class="flex flex-col md:flex-row items-end md:items-center gap-1"
                    >
                        <TextInput
                            type="time"
                            step="300"
                            :name="`${RequestBodyKeyEnum.App_Availability_DateSpecificHours}[${index}][${RequestBodyKeyEnum.App_Availability_DateSpecificHour_TimeRanges}][${timeRangeIndex}][${RequestBodyKeyEnum.App_Availability_DateSpecificHour_TimeRange_StartAt}]`"
                            v-model="timeRange.start"
                            required
                        />
                        <TextInput
                            type="time"
                            step="300"
                            :name="`${RequestBodyKeyEnum.App_Availability_DateSpecificHours}[${index}][${RequestBodyKeyEnum.App_Availability_DateSpecificHour_TimeRanges}][${timeRangeIndex}][${RequestBodyKeyEnum.App_Availability_DateSpecificHour_TimeRange_EndAt}]`"
                            v-model="timeRange.end"
                            required
                        />
                        <Button
                            type="button"
                            iconName="trash"
                            color="danger-outline"
                            @click="handleRemoveTimeRange(timeRange.id)"
                        />
                    </div>
                </div>
            </div>
        </div>
        <div class="flex justify-end mt-2">
            <Button
                type="button"
                @click="handleAddTimeRange()"
                iconName="plus"
                color="light"
                size="small"
            >
                Add time slot
            </Button>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { ref, type PropType } from 'vue'
    import TextInput from '@/Shared/Component/Forms/TextInput.vue'
    import {
        type DateSpecificHoursType,
        type TimeRangeType,
    } from '@/Shared/AutoGenerated/Main'
    import Button from '@/Shared/Component/Button.vue'
    import useId from '@/Shared/Hook/useId'
    import { RequestBodyKeyEnum } from '@/Shared/AutoGenerated/RequestFieldEnum'

    const emits = defineEmits<{
        onDelete: [{ id: string }]
    }>()

    const props = defineProps({
        dateSpecificHours: {
            type: Object as PropType<DateSpecificHoursType>,
            required: true,
        },
        index: {
            type: Number,
            required: true,
        },
    })

    const dummyStartDate = ref<string>(props.dateSpecificHours.startDate)
    const dummyEndDate = ref<string>(props.dateSpecificHours.endDate)

    const localDateSpecificHours = ref<DateSpecificHoursType>(
        props.dateSpecificHours,
    )

    const handleAddTimeRange = (): void => {
        localDateSpecificHours.value = {
            id: localDateSpecificHours.value.id,
            startDate: localDateSpecificHours.value.startDate,
            endDate: localDateSpecificHours.value.endDate,
            timeRanges: [
                ...localDateSpecificHours.value.timeRanges,
                {
                    id: useId().make(),
                    start: '09:00',
                    end: '17:00',
                },
            ],
        }
    }

    const handleRemoveTimeRange = (id: string): void => {
        localDateSpecificHours.value = {
            id: localDateSpecificHours.value.id,
            startDate: localDateSpecificHours.value.startDate,
            endDate: localDateSpecificHours.value.endDate,
            timeRanges: localDateSpecificHours.value.timeRanges.filter(
                (timeRange: TimeRangeType) => timeRange.id !== id,
            ),
        }
    }

    const handleDeleteDateSpecificHour = () => {
        emits('onDelete', {
            id: props.dateSpecificHours.id,
        })
    }
</script>
